import { InputText } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';
import { INPUT_OPTIONS_SIZES } from '@insurancemenu/imenu-components-lib/dist/utils/forms/dynamic-forms/constants';

export const InputTextStyled = styled(InputText)`
  width: ${INPUT_OPTIONS_SIZES.large};
  ${breakpointsMQ4.sm.down} {
    width: 100%;
  }
`;
